import useCapabilities, { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";

const PBD_CARD_MANUAL_FULFILLMENT_ROLES = [ROLE.GLOBAL_ADMIN, ROLE.MEMBERSHIP_SERVICES_ADMIN] as const;

export const PBD_CARD_MANUAL_FULFILLMENT_PATH = "/people/membership-services/pbd-card-manual-fulfillment" as const;

export const PBD_CARD_MANUAL_FULFILLMENT_SUBTEXT =
  "This will queue a job to send an adhoc PBD credential request for Associates and Member cards";

export const PBD_CARD_MANUAL_FULFILLMENT_MAX_PEOPLE = 1000;

export function canQueuePbdCardManualFulfillment(
  hasGlobalAdminRole: boolean,
  hasMembershipServicesAdminRole: boolean
): boolean {
  return hasGlobalAdminRole || hasMembershipServicesAdminRole;
}

export function usePbdCardManualFulfillmentAccess() {
  const { loaded } = useCapabilities();
  const hasAllowedRole = useHasRoles([...PBD_CARD_MANUAL_FULFILLMENT_ROLES]);

  return { loaded, canQueue: hasAllowedRole };
}
